import React from 'react'
import lottie from 'lottie-web'
import animationData from '../../static/animations/worldwide-animation.json'

export default class WWAnimation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      width: this.getAnimationWidth(),
    }
  }

  componentDidMount() {
    if (window) {
      window.addEventListener('resize', this.updateWidth)
    }
    lottie.loadAnimation({
      container: this.getAnimationElement(), // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData,
    })
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.updateWidth)
    }
  }

  render() {
    return (
      <div
        id={'animation'}
        style={{
          width: this.state.width,
          ...this.props.style,
        }}
      />
    )
  }

  getAnimationWidth = () => {
    if (window) {
      if (this.props.viewWidth) {
        return window.innerWidth * (this.props.viewWidth / 100)
      }
      return window.innerWidth - 4 * 14
    }
    return 0
  }

  updateWidth = () => this.setState({ width: this.getAnimationWidth() })

  getAnimationElement = () => {
    if (document) {
      return document.getElementById('animation')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/homepage/worldwideAnimation.js